import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'
import SubImportMenuItem from './SubImportMenuItem'
import Container from '@mui/material/Container'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import MultipleSelect from '../MultiSelect'
import EditableSelect from '../EditableSelect'

import TextField from '@mui/material/TextField'

import { useZustand } from '../../hooks/useZustand'
import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import usePageInfo from '../../hooks/usePageInfo'

import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { generateNewsImportItems } from './NewsImportItems'

import { SubImportContext } from './SubImportContext'
import { DialogsContext } from '../../DialogsContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

import axios from 'axios'
import Papa from 'papaparse'

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material'

import { useDropzone } from 'react-dropzone'
import {
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    ListItemSecondaryAction,
} from '@mui/material'
import { InsertDriveFile, Delete } from '@mui/icons-material'
import { slugifyString } from '../../utils'
import ImportingNotice from './ImportingNotice'
import { importErrorMessage } from './importError'

const addPrivateStatementsSelector = state => state.addPrivateStatementsToStore

const steps = ['File', 'Destination', 'Process']

export default function GexfFileImportDialog({ presetContext, open, onClose }) {
    const theme = useTheme() // hook to get the current theme

    const { label, location } = usePageInfo()

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const { presetFiles, closeImportDialog } = React.useContext(DialogsContext)

    const preSelectedContext = presetContext
        ? presetContext
        : generatePresetContext()

    const [selectedContext, addToSelectedContext] = React.useState(
        preSelectedContext
    )

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [selectedFeeds, setSelectedFeeds] = React.useState([])

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [filesAsNodes, setFilesAsNodes] = React.useState('0')

    const [filterBySpeakers, setFilterBySpeakers] = React.useState(false)

    const [fileType, setFileType] = React.useState('')

    const [doubleSquareBrackets, setDoubleSquareBrackets] = React.useState(
        'PROCESS_AS_HASHTAGS'
    )

    const [squareBrackets, setSquareBrackets] = React.useState('')

    const [advancedSettings, setAdvancedSettings] = React.useState(false)

    const [advancedFilterSettings, setAdvancedFilterSettings] = React.useState(
        false
    )

    const [addColumnNameToFilter, setAddColumnNameToFilter] = React.useState(
        true
    )

    const [delimiter, setDelimiter] = React.useState(';')

    const [doNotSaveGraph, setDoNotSaveGraph] = React.useState(false)

    const [fromInsideContext, setFromInsideContext] = React.useState(false)

    const { username } = React.useContext(UserContext)
    const addPrivateStatementsToStore = useZustand(addPrivateStatementsSelector)

    React.useEffect(() => {
        if (location == 'context' && label) {
            setFromInsideContext(true)
        }
    }, [label])

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const handleChange = (_, newValue) => {
        setValue(newValue)
    }

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    const [files, setFiles] = React.useState(presetFiles)

    const [fileContent, setFileContent] = React.useState([]) // To store the parsed content

    const [fileName, setFileName] = React.useState('')
    const [columns, setColumns] = React.useState([])
    const [filters, setFilters] = React.useState([])

    const [removeDuplicates, setRemoveDuplicates] = React.useState(false)

    const [columnForTimestamp, setColumnForTimestamp] = React.useState('none')

    const [universalTag, setUniversalTag] = React.useState('')

    const [splitByColumn, setSplitByColumn] = React.useState('none')

    const [superlinkedColumn, setSuperlinkedColumn] = React.useState('none')

    const [modifyAnalyzedText, setModifyAnalyzedText] = React.useState('none')

    const [replaceEntities, setReplaceEntities] = React.useState(false)

    const fileInputRef = React.useRef()

    React.useEffect(() => {
        if (!presetContext)
            addToSelectedContext(
                generatePresetContext(
                    'gexf',
                    slugifyString(fileName).slice(0, 12)
                )
            )
        setUniversalTag(`file: ${slugifyString(fileName).slice(0, 32)}`)
    }, [fileName])

    const onDrop = React.useCallback(acceptedFiles => {
        const droppedFiles = acceptedFiles
        handleAddedFiles(droppedFiles)
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        // accept: 'application/pdf, text/plain', // Produces an error but looks like it's not necessary
    })

    const onFilesAdded = event => {
        const addedFiles = Array.from(event.target.files)
        handleAddedFiles(addedFiles)
    }

    React.useEffect(() => {
        const existPresetFiles =
            presetFiles && presetFiles.length > 0 ? true : false
        if (existPresetFiles) handleAddedFiles(presetFiles)
    }, [])

    const handleAddedFiles = addedFiles => {
        const uploadedFiles = addedFiles.filter(file => {
            const determinedType = determineFileType(file)
            switch (determinedType) {
                case '.gexf':
                    setFileType('gexf')
                    break
            }
            return determinedType === '.gexf'
        })

        setFiles([...uploadedFiles])
    }

    const handleDelete = fileToDelete => () => {
        setFiles(prevFiles => prevFiles.filter(file => file !== fileToDelete))
    }

    const openFileDialog = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click()
        }
    }

    const fileList = files.reverse().map((file, index) => {
        return (
            <ListItem key={index}>
                <ListItemIcon>
                    <InsertDriveFile />
                </ListItemIcon>
                <ListItemText
                    primary={file.name}
                    secondary={`${file.size} bytes`}
                />
                <ListItemSecondaryAction>
                    <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={handleDelete(file)}
                    >
                        <Delete />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        )
    })

    const submitDataForm = () => {
        const formData = new FormData()

        // Append the files to the FormData object
        files.forEach(file => {
            formData.append('uploadedFile', file) // 'files' is the key for the server
        })

        formData.append('source', 'file')

        formData.append('context', selectedContext)

        if (doNotSaveGraph) {
            formData.append('doNotSaveGraph', 'true')
        }

        if (doubleSquareBrackets) {
            formData.append(
                'doubleSquarebracketsProcessing',
                doubleSquareBrackets
            )
        }

        axios
            .post('/import/graphs', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(0)
                    }
                    if (response.data.entryuid) {
                        const postedby = username
                        const res = response.data

                        // Handle private mode statements
                        if (doNotSaveGraph && res.statements) {
                            // Private mode: add statements to Zustand store without saving to DB
                            const entryuids = JSON.parse(res.entryuid)
                            const statementHashtags =
                                res.statementHashtags || {}
                            addPrivateStatementsToStore(
                                res.statements,
                                selectedContext,
                                entryuids,
                                statementHashtags
                            )
                        }

                        if (
                            window.myEventEmitter &&
                            myEventEmitter._events['chatMessage']
                        ) {
                            myEventEmitter.emit('chatMessage', {
                                source: null,
                                postedby: postedby,
                                entryuid: JSON.parse(res.entryuid),
                                entrytext: JSON.parse(res.entrytext),
                                entryname: JSON.parse(res.entryname),
                                tags: JSON.parse(res.tags),
                                timestamp: JSON.parse(res.timestamp),
                                graph: res.graph,
                                stimulateVariability: false,
                                message: res.message,
                                statementHashtags: res.statementHashtags || {},
                                doNotSaveGraph: doNotSaveGraph,
                            })
                            closeImportDialog()
                        }
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.")
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(prevSkipped => {
            const newSkipped = new Set(prevSkipped.values())
            newSkipped.add(activeStep)
            return newSkipped
        })
    }

    const handleReset = () => {
        setActiveStep(0)
    }

    React.useEffect(() => {
        if (activeSubImportDialog.content) {
            setActiveStep(1)
            setSelectedFeeds(activeSubImportDialog.content)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        setImportError(null)
    }, [selectedFeeds])

    React.useEffect(() => {
        if (fileType === 'markdown') {
            setDoubleSquareBrackets('PROCESS_AS_MENTIONS')
            setFilesAsNodes('1')
            setSquareBrackets('IGNORE_BRACKETS')
        }
    }, [fileType])

    React.useEffect(() => {
        switch (activeStep) {
            case 1:
                if (files.length > 0) {
                    if (files[0].name)
                        setFileName(
                            files[0].name.split('.')[0].replace(/ /g, '_')
                        )

                    setCompletedSteps([...completedSteps, 0, 1])
                    setErrorMessage(null)
                    setVisitedContext(true)

                    if (!presetContext) {
                        addToSelectedContext(
                            generatePresetContext(fileType, fileName)
                        )
                    }

                    break
                }
            case 2:
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 3])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
                setActiveStep(2)
                break
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {'Analyze a Gephi (.gexf) File'}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Box sx={{ p: 2 }}>
                                <Paper
                                    {...getRootProps()}
                                    onClick={openFileDialog} // Here we make the Paper component click event trigger the input click
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        height: '200px',
                                        borderStyle: 'dashed',
                                        borderColor: isDragActive
                                            ? 'primary.main'
                                            : 'grey.400',
                                        backgroundColor: isDragActive
                                            ? 'background.default'
                                            : 'background.paper',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Typography variant="body1">
                                        Drag and drop the .Gexf file you'd like
                                        to analyze here, or click to select and
                                        upload manually.
                                    </Typography>

                                    <input
                                        {...getInputProps()}
                                        ref={fileInputRef}
                                        accept=".gexf"
                                        onChange={onFilesAdded}
                                        style={{ display: 'none' }}
                                        multiple={false}
                                    />
                                </Paper>
                                <Box sx={{ m: 2 }}>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        onClick={openFileDialog}
                                    >
                                        Select & Upload New File
                                    </Button>
                                </Box>

                                <List>{fileList}</List>
                            </Box>
                        </DialogContent>
                    </>
                )}

                {activeStep === 1 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <Grid container spacing={8}>
                                <Grid item xs={12} sm={5}>
                                    <DialogContentText>
                                        Please, choose the context to import
                                        your content to:
                                    </DialogContentText>
                                    <FormControl
                                        fullWidth
                                        sx={{ marginTop: 4 }}
                                    >
                                        <EditableSelect
                                            selectItems={contextNames}
                                            label={'Contexts'}
                                            initialValue={selectedContext}
                                            onChange={name =>
                                                addToSelectedContext(name)
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    {' '}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </>
                )}
                {activeStep === 2 && (
                    <ImportingNotice
                        linkHref={`/${username}/${selectedContext}/edit`}
                    />
                )}
                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>
                    {/* {isStepOptional(activeStep) && (
                        <Button
                            color="inherit"
                            onClick={handleSkip}
                            sx={{ mr: 1 }}
                        >
                            Skip
                        </Button>
                    )} */}
                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!files.length > 0}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function generatePresetContext(type, fileName) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    const typeString = type ? `${slugifyString(type)}_` : 'gexf_'
    const nameString = fileName
        ? slugifyString(fileName).slice(0, 12)
        : dateAndTime

    return `${typeString}${nameString}`
}

const determineFileType = file => {
    if (
        (!file.type || file.type === 'application/octet-stream') &&
        file.name.endsWith('.gexf')
    ) {
        return '.gexf'
    } else {
        return null
    }
}
